import { render, staticRenderFns } from "./SettingProjectHrm.vue?vue&type=template&id=b4389eb2"
import script from "./SettingProjectHrm.vue?vue&type=script&lang=js"
export * from "./SettingProjectHrm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports